import React, { FC } from 'react';
import { useFetchOnlineDocumentsQuery } from 'rtkQuery/sharespro/queries/profile';
import { Box, Center, Divider, Flex, Spinner, Text } from '@chakra-ui/react';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import AppCard from 'presentation/components/shared/card/AppCard';
import useQueryParam from 'hooks/shared/useQueryParam';
import PaginationContentWrap from 'presentation/components/shared/pagination/PaginationContentWrap';
import { useTranslation } from 'react-i18next';
import SettingsLayout from 'presentation/layout/modules/settings/SettingsLayout';
import { Helmet } from 'react-helmet-async';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import OnlineDocumentListCard from 'presentation/components/modules/onlineDocuments/OnlineDocumentListCard';

const MyDocumentsPage: FC = () => {
  const [page, setPage] = useQueryParam<number>('page', {
    ifAbsent: 1,
    provider: (val) => parseInt(val),
  });
  const { data, isFetching, error, refetch } =
    useFetchOnlineDocumentsQuery({ page });
  const { t } = useTranslation();
  const hasSignDocuments = data && data.items.length > 0 && data.items[0].isSigned;
  let wrapByCard = true;
  let content;
  if (data) {
    if (data.items.length > 0) {
      content = (
        <PaginationContentWrap
          itemsCount={data.itemsCount}
          isFetching={isFetching}
          setPage={setPage}
          currentPage={data.currentPage}
          pageCount={data.pageCount}
        >
          {data.items.map((document, index) => {
            return (
              <Box key={document.id}>
                <Box my="10px">
                  <OnlineDocumentListCard document={document} hasSignDocuments={hasSignDocuments ?? false}/>
                </Box>
                {index !== data.items.length - 1 && (<Divider/>)}
              </Box>
            );
          })}
        </PaginationContentWrap>
      );
      wrapByCard = false;
    } else {
      content = <Text textAlign="center">{t('listIsEmpty')}</Text>;
    }
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }
  if (wrapByCard) {
    content = (
      <AppCard p="20">
        <Center>{content}</Center>
      </AppCard>
    );
  }

 return <SettingsLayout>
    <Helmet>
      <title>{t('myDocuments')}</title>
    </Helmet>
    <GridHeading>{t('myDocuments')}</GridHeading>
    <AppCard w="100%" pr="20px" pl="20px" pt="15px" pb="15px">
      <Flex pb="10px">
        <Center flex={1}>{t('orderDate')}</Center>
        <Center flex={2} justifyContent="center">{t('orderName')}</Center>
        <Center flex={2} justifyContent="center">{t('orderStatus')}</Center>
        {!hasSignDocuments && (<Center flex={2}></Center>)}
      </Flex>
      <Divider/>
      {content}
    </AppCard>
  </SettingsLayout>;
};

export default MyDocumentsPage;
